export const headerGradient = "bg-gradient-to-r from-primary via-secondary to-teritary";

/** Uses --titleheight from theme variables.css when set; otherwise responsive defaults (28/40/53). */
export const defaultHeaderLogoClassName =
  "h-[var(--titleHeight,28px)] md:h-[var(--titleHeight,40px)] lg:h-[var(--titleHeight,53px)] md:my-2 lg:my-0 cursor-pointer";

export const commonPaddingBottomForMobile = "pb-[65px] md:pb-1";
